// extracted by mini-css-extract-plugin
module.exports =  {"label":"style-module_label__hGBeeiJqM5oo_LDYgD8o","numberPicker":"style-module_numberPicker__w2qslamPAzw0hsFx1zPg","digit":"style-module_digit__nGkI02BeBt4rU00jTsym"};